import { render, staticRenderFns } from "./TransferList.vue?vue&type=template&id=5efabe7d&scoped=true&"
import script from "./TransferList.vue?vue&type=script&lang=js&"
export * from "./TransferList.vue?vue&type=script&lang=js&"
import style0 from "./TransferList.vue?vue&type=style&index=0&id=5efabe7d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5efabe7d",
  null
  
)

export default component.exports